import { render } from "./fundamental1.vue?vue&type=template&id=64a6c7fa&scoped=true"
import script from "./fundamental1.vue?vue&type=script&lang=js"
export * from "./fundamental1.vue?vue&type=script&lang=js"

import "./fundamental1.vue?vue&type=style&index=0&id=64a6c7fa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a6c7fa"]])

export default __exports__